module.exports = __webpack_public_path__ + "img/5b.9b7c50ee.svg";